if(!__webpack_require__.federation){
	__webpack_require__.federation = {
		initOptions: {"name":"Physician Webapp","remotes":[{"alias":"RemoteInbox","name":"RemoteInbox","entry":"https://app.int2.medflex.de/inbox/moduleEntry.js","shareScope":"default"},{"alias":"RemoteWidget","name":"RemoteWidget","entry":"https://app.int2.medflex.de/widget/moduleEntry.js","shareScope":"default"},{"alias":"RemoteActivities","name":"RemoteActivities","entry":"https://app.int2.medflex.de/activities/mf-manifest.json","shareScope":"default"}]},
		chunkMatcher: function(chunkId) {return !/^(3([09]02|076|301|570|666)|6(017|202|892)|9(429|441|652)|2509|4117|5712|5819|7820|8475)$/.test(chunkId)},
		rootOutputDir: "",
		initialConsumes: undefined,
		bundlerRuntimeOptions: {}
	};
}